<div *ngIf="this.state">
  <div class="page-data shadow-sm">
    <div class="amb-15">
      <div class="tabs">
        <div class="tabs-items">

          <div class="tab-item" *ngFor="let tab of tabs" [ngClass]="{ active: tab.active, disabled: tab.disabled }"
               (click)="!tab.disabled && setTabActive(tab.identifier)">


            <!--            <div *ngIf="this.requestId && this.state">-->
            <!--              <ng-container *ngIf="tab.identifier == requestTabs.BasicInformation">-->
            <!--                <div class="tab-item-icon">-->
            <!--                  <span>-->
            <!--                    <i class="fa-solid fa-align-left"></i>-->
            <!--                  </span>-->
            <!--                </div>-->
            <!--                <span>{{ translationManager.getTranslation('Захтеви - општи подаци') }}</span>-->
            <!--              </ng-container>-->

            <!--            </div>-->
            <!--            <ng-container *ngIf="tab.identifier == requestTabs.OpnConsents">-->
            <!--              <div class="tab-item-icon">-->
            <!--                <span>-->
            <!--                  <i class="fa-solid fa-align-left"></i>-->
            <!--                </span>-->
            <!--              </div>-->
            <!--              <span>{{ translationManager.getTranslation('Преглед датих сагласности') }}</span>-->
            <!--            </ng-container>-->

            <ng-container *ngIf="tab.identifier == requestTabs.Introduction">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-file"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Увод') }}</span>
            </ng-container>

            <ng-container *ngIf="tab.identifier == requestTabs.OpnOfferEvaluationMethods">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-file"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Метод оцењивања понуда') }}</span>
            </ng-container>

            <ng-container *ngIf="tab.identifier == requestTabs.RequirementList">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-file"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Листа обавезних захтева') }}</span>
            </ng-container>

            <ng-container *ngIf="tab.identifier == requestTabs.OpnCommercialLegalTerm">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-file"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Комерцијално правни услови') }}</span>
            </ng-container>

            <ng-container *ngIf="tab.identifier == requestTabs.OpnProjectdeadlinesList">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-file"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Листа дефинисаних рокова пројекта') }}</span>
            </ng-container>

            <ng-container *ngIf="tab.identifier == requestTabs.Documents">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-file"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Документи') }}</span>
            </ng-container>


            <ng-container *ngIf="tab.identifier == requestTabs.Communication">
              <div class="tab-item-icon">
                <span>
                  <i class="fa-solid fa-comment"></i>
                </span>
              </div>
              <span>{{ translationManager.getTranslation('Комуникација') }}</span>
            </ng-container>
          </div>
        </div>


        <div class="tabs-content-container">
          <ng-container *ngFor="let tab of tabs">
            <div class="tabs-content" *ngIf="tab.active">

              <!--              <ng-container *ngIf="tab.identifier == requestTabs.BasicInformation">-->
              <!--                <request-basic-information [id]="this.requestId" [state]="this.state"></request-basic-information>-->
              <!--              </ng-container>-->

              <!--              <ng-container *ngIf="tab.identifier == requestTabs.OpnConsents">-->
              <!--                <opn-consents [id]="this.requestId" [state]="this.state"></opn-consents>-->
              <!--              </ng-container>-->

              <ng-container *ngIf="tab.identifier == requestTabs.Introduction">
                <opn-introduction [requestId]="this.requestId" [state]="viewState.Details"></opn-introduction>
              </ng-container>

              <ng-container *ngIf="tab.identifier == requestTabs.OpnOfferEvaluationMethods">
                <opn-offer-evaluation-methods [requestId]="this.requestId" [state]="viewState.Details"
                                              (checkTabs)="checkTabs($event)">
                </opn-offer-evaluation-methods>
              </ng-container>

              <!--              <ng-container *ngIf="tab.identifier == requestTabs.OpnOfferEvaluationMembers">-->
              <!--                <opn-team-members [requestId]="this.requestId" [state]="this.state">-->
              <!--                </opn-team-members>-->
              <!--              </ng-container>-->

              <!--              <ng-container *ngIf="tab.identifier == requestTabs.OpnBoardMembersList">-->
              <!--                <opn-boardmembers-list [requestId]="this.requestId" [state]="this.state"></opn-boardmembers-list>-->
              <!--              </ng-container>-->

              <!--              <ng-container *ngIf="tab.identifier == requestTabs.OpnSuppliersList">-->
              <!--                <opn-suppliers-list [requestId]="this.requestId" [state]="this.state"></opn-suppliers-list>-->
              <!--              </ng-container>-->

              <ng-container *ngIf="tab.identifier == requestTabs.RequirementList">
                <!--                <app-request-items-list-view-ssy1210list [requestId]="this.requestId"></app-request-items-list-view-ssy1210list>-->
                <app-supplier-offer-item-ssy1240list [state]="state"
                                                     (newSupplierOfferEvent)="onNewSupplierOfferEvent($event)"
                                                     [supplierOfferId]="supplierOfferId" [requestId]="requestId"
                                                     [requestRoundId]="requestRoundId"
                                                     [procurementModelUniqueIdentifier]="procurementModelUniqueIdentifier"
                                                     [isAuctionStarted]="isAuctionStarted"
                ></app-supplier-offer-item-ssy1240list>
              </ng-container>

              <ng-container *ngIf="tab.identifier == requestTabs.OpnCommercialLegalTerm">
                <app-request-items-legal-term-list-ssy1220list [state]="state"
                                                               [supplierOfferId]="supplierOfferId"></app-request-items-legal-term-list-ssy1220list>
              </ng-container>

              <ng-container *ngIf="tab.identifier == requestTabs.OpnProjectdeadlinesList">
                <opn-projectdeadlines-list [requestId]="this.requestId" [supplierOfferId]="this.supplierOfferId"
                                           [state]="viewState.Details">
                </opn-projectdeadlines-list>
              </ng-container>


              <ng-container *ngIf="tab.identifier == requestTabs.Documents">
                <supplier-offer-documents
                  [supplierOfferId]="this.supplierOfferId"
                  [state]="this.state"
                ></supplier-offer-documents>
              </ng-container>

              <ng-container *ngIf="tab.identifier == requestTabs.Communication">
                <!--                <request-messages [id]="this.requestId" [state]="this.state"></request-messages>-->
                <supplier-offer-messages [id]="this.supplierOfferId" [state]="this.state"></supplier-offer-messages>
              </ng-container>

            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="app-form-element-buttons">
      <button class="btn btn-warning fl amno" (click)="navigateToBack()">
        <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
    </div>
  </div>
</div>
